import nextId from 'react-id-generator';

export const generatedIdMapper = <T>(items: T[], idName: string): T[] =>
  items?.map((item: T) => ({
    ...item,
    generatedId: nextId(idName),
  }));
